export const SET_VALUE_REQUEST = 'SET_VALUE_REQUEST'
export const SET_VALUE_FAILURE = 'SET_VALUE_FAILURE'
export const SET_VALUE_SUCCESS = 'SET_VALUE_SUCCESS'
